import { Fragment } from 'react';

import {
  APPAREL_GENDER_OPTIONS, APPAREL_GENDER_VALUE_MEN, APPAREL_SIZE_OPTIONS,
  APPAREL_TYPE_NAME_SHOE, MEN_SHOE_SIZE_OPTIONS, WOMEN_SHOE_SIZE_OPTIONS
} from './ApparelFormGridConstants';

import Dropdown from '@usas/ui-web/components/dropdowns/Dropdown';

import global from '@usas/ui-web/components/GlobalStyle.module.css';
import style from './ApparelFormGrid.module.css';
import ReadOnly from '@usas/ui-web/components/readOnly/ReadOnly';

const GridRow = ({ apparel, onUpdateApparelGender, onUpdateApparelSize }) => {
  if (apparel.name.includes(APPAREL_TYPE_NAME_SHOE)) {
    const apparelGenderOption = APPAREL_GENDER_OPTIONS.find((x) => x.id === apparel.apparelGenderId) || APPAREL_GENDER_OPTIONS[0];
    const apparelSizeOptions = apparelGenderOption.value === APPAREL_GENDER_VALUE_MEN
      ? MEN_SHOE_SIZE_OPTIONS
      : WOMEN_SHOE_SIZE_OPTIONS;

    return (
      <div className={global.SmallTableRow}>
        <div className={global.SmallTableRowHead}>
          <span>{apparel.name || <span>&nbsp;</span>}</span>&nbsp;
        </div>
        <div className={global.SmallTableRowInfo}>
          <div className='row'>
            <div className={['col-xs-12', global.SmallTableRowData].join(' ')}>
              {apparel.hasGenderType === true
                ? (
                  <Dropdown
                    label={'Apparel Type'}
                    name={`apparelGenderId${apparel.id}`}
                    value={apparel.apparelGenderId}
                    isLoading={false}
                    options={APPAREL_GENDER_OPTIONS.filter((x) => x.displayInDropdown === true)}
                    onChange={(newValue, newValueLabel, e) => { e?.target?.value && onUpdateApparelGender(apparel.id, newValue) }} />
                ) : (
                  <ReadOnly
                    label={'Apparel Type'}
                    name={`apparelGenderId${apparel.id}`}
                    value={APPAREL_GENDER_OPTIONS.find((x) => x.id === apparel.apparelGenderId)?.name || ''} />
                )}
            </div>
            <div className={['col-xs-12', global.SmallTableRowData].join(' ')}>
              <Dropdown
                label={'Apparel Size'}
                name={`apparelSizeId${apparel.id}`}
                value={apparel.apparelSizeId}
                isLoading={false}
                options={apparelSizeOptions}
                onChange={(newValue, newValueLabel, e) => { e?.target?.value && onUpdateApparelSize(apparel.id, newValue) }} />
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={global.SmallTableRow}>
      <div className={global.SmallTableRowHead}>
        <span>{apparel.name || <span>&nbsp;</span>}</span>&nbsp;
      </div>
      <div className={global.SmallTableRowInfo}>
        <div className='row'>
          <div className={['col-xs-12', global.SmallTableRowData].join(' ')}>
            {apparel.hasGenderType === true
              ? (
                <Dropdown
                  label={'Apparel Type'}
                  name={`apparelGenderId${apparel.id}`}
                  value={apparel.apparelGenderId}
                  isLoading={false}
                  options={APPAREL_GENDER_OPTIONS.filter((x) => x.displayInDropdown === true)}
                  onChange={(newValue, newValueLabel, e) => { e?.target?.value && onUpdateApparelGender(apparel.id, newValue) }} />
              ) : (
                <ReadOnly
                  label={'Apparel Type'}
                  name={`apparelGenderId${apparel.id}`}
                  value={APPAREL_GENDER_OPTIONS.find((x) => x.id === apparel.apparelGenderId)?.name || ''} />
              )}
          </div>
          <div className={['col-xs-12', global.SmallTableRowData].join(' ')}>
            <Dropdown
              label={'Apparel Size'}
              name={`apparelSizeId${apparel.id}`}
              value={apparel.apparelSizeId}
              isLoading={false}
              options={APPAREL_SIZE_OPTIONS}
              onChange={(newValue, newValueLabel, e) => { e?.target?.value && onUpdateApparelSize(apparel.id, newValue) }} />
          </div>
          <div className={['col-xs-12', global.SmallTableRowData].join(' ')}>
            {apparel.hasValue === true &&
              <Fragment>
                <button
                  className={style.GridActionButton}
                  type="button"
                  onClick={() => onUpdateApparelSize(-1, apparel.apparelSizeId)}>
                  Apply Size To All
                </button>
              </Fragment>
            }
          </div>
        </div>
      </div>
    </div >
  );
}

const ApparelFormGridSmall = ({ formGridState, onUpdateApparelGender, onUpdateApparelSize }) => (
  <div className={[global.SmallTable, style.SmallFormGrid, 'hidden-md hidden-lg'].join(' ')}>
    {Array.isArray(formGridState) && formGridState.length > 0
      ? formGridState.map((apparel, i) => <GridRow key={i} apparel={apparel} onUpdateApparelGender={onUpdateApparelGender} onUpdateApparelSize={onUpdateApparelSize} />)
      : (
        <div className={global.SmallTableRow}>
          <div className={global.SmallTableRowHead}>&nbsp;</div>
          <div className={[global.SmallTableRowInfo, global.Bold].join(' ')}>
            &nbsp;&nbsp;No Apparel
          </div>
        </div>
      )
    }
  </div>
);

export default ApparelFormGridSmall;